import axios from 'axios';
import Swal from 'sweetalert2'
import '@sweetalert2/theme-material-ui/material-ui.css';
import './ui.css';
import inApp from './inapp.js';
import jquery from 'jquery';
import qs from 'qs';
import ui from './ui.js';


function cookie_encode(string) {
    //full uri decode not only to encode ",; =" but to save uicode charaters
    var decoded = encodeURIComponent(string);
    //encod back common and allowed charaters {}:"#[] to save space and make the cookies more human readable
    var ns = decoded.replace(/(%7B|%7D|%3A|%22|%23|%5B|%5D)/g, function (charater) { return decodeURIComponent(charater); });
    return ns;
}

var mainWindow = null;

var domain = "x-legend.com";
var tokenKey = "xToken";
var expireKey = "xExpire";

var gameType = Number(jquery(document.currentScript).attr("d-type")) || 2;

var inapp = new inApp();
(async () => {
    await inapp.init();
})()
class mapi1 {
    constructor() {
        this.debug = false;
        if (this.cookie("mapi_url") == null || this.cookie("mapi_url") == "") {
            this.api_url = "https://web-api.x-legend.com/api/m_api.php?jsoncallback=?"
        } else {
            this.api_url = this.cookie("mapi_url");
        }

        if (this.cookie("wapi_url") == null || this.cookie("wapi_url") == "") {
            this.wapi_url = "https://w-api.x-legend.com"
        } else {
            this.wapi_url = this.cookie("wapi_url");
        }

        if (this.cookie("app_url") == null || this.cookie("app_url") == "") {
            this.app_url = "https://app.x-legend.com"
        } else {
            this.app_url = this.cookie("app_url");
        }

        this.timeout = 1000;
        this.paymentList = {};
        this.querylog = {};
        this.listPage = 0;
        this.curPage = 0;
        this.maxPage = 0;
        this.xToken = '';

        this.gameList = null;
        this.myGameList = null;

        this.inapp = inapp

        this.pages = {
            login: "https://xplus.x-legend.com.tw/member/login/",
            register: "https://xplus.x-legend.com.tw/member/register/",
            logout: "https://xplus.x-legend.com.tw/member/logout/",
            topup: "https://xplus.x-legend.com.tw/member/purchase/",
            default: "https://xplus.x-legend.com.tw/member/"
        };

        this.getConfig();
    }

    /**
     * Represents a book.
     * @constructor
     */
    getConfig() {
        const config = {
            "x-legend.com.tw": {
                app_url: "https://app.x-legend.com",
                wapi_url: "https://w-api.x-legend.com",
                mapi_url: "https://web-api.x-legend.com/api/m_api.php?jsoncallback=?",
                pages: {
                    login: "https://xplus.x-legend.com.tw/login/login.php",
                    register: "https://xplus.x-legend.com.tw/member/register/",
                    logout: "https://xplus.x-legend.com.tw/member/logout/",
                    topup: "https://xplus.x-legend.com.tw/member/purchase/",
                    default: "https://xplus.x-legend.com.tw/cs/"
                }
            },
            "x-legend.com": {
                app_url: "https://app.x-legend.com",
                wapi_url: "https://w-api.x-legend.com",
                mapi_url: "https://web-api.x-legend.com/api/m_api.php?jsoncallback=?",
                pages: {
                    login: "https://www.x-legend.com/member/login/",
                    register: "https://www.x-legend.com/member/register/",
                    logout: "https://www.x-legend.com/member/logout/",
                    topup: "https://www.x-legend.com/member/purchase/",
                    default: "https://www.x-legend.com/member/"
                }
            }
        };
        let host = window.location.host;
        let ret = {}
        if (/x\-legend\.com$/.test(host)) {
            ret = config["x-legend.com"];
            domain = "x-legend.com";
            tokenKey = "xToken2";
            expireKey = "xExpire2";
        } else {
            ret = config["x-legend.com.tw"];
            domain = "x-legend.com.tw";
            tokenKey = "xToken";
            expireKey = "xExpire";
        }


        if (this.cookie("mapi_url") == null || this.cookie("mapi_url") == "") {
            ret.api_url = "https://web-api.x-legend.com/api/m_api.php?jsoncallback=?"
        } else {
            ret.api_url = this.cookie("mapi_url");
        }

        if (this.cookie("wapi_url") == null || this.cookie("wapi_url") == "") {
            ret.wapi_url = "https://w-api.x-legend.com"
        } else {
            ret.wapi_url = this.cookie("wapi_url");
        }

        if (this.cookie("app_url") == null || this.cookie("app_url") == "") {
            ret.app_url = "https://app.x-legend.com"
        } else {
            ret.app_url = this.cookie("app_url");
        }

        return ret;
    }

    load(prog) {
        try {
            document.write("<script src='" + prog + "'></script>")
        } catch (err) {

        }
    }

    call() {
        switch (arguments.length) {
            case 3:
                this.call_single(arguments[0], arguments[1], arguments[2]);
                break;
            case 4:
                // post mode without jsonp
                this.call_post(arguments[0], arguments[1], arguments[2]);
                break;
            default:
                break;
        }
    }



    async call_post(m, args, cb_func) {
        if (typeof args == 'object') {
            args['method'] = m;
        } else {
            args = { 'method': m };
        }
        this._log("=== API Query ( POST mode )");
        this._log("api_url: " + this.getConfig().api_url);
        this._log("args:");
        this._log(args);

        let user = this.getUser();
        args['xToken'] = user.xToken;

        args['rp_data_type'] = 'json';

        let ret = await axios.post(this.getConfig().api_url, qt.stringify(args))
        cb_func(ret['data']);
    }

    async call_single(m, args, cb_func) {
        var api_url = this.getConfig().api_url;
        if (typeof args == 'object') {
            args['method'] = m;
        } else {
            args = { 'method': m };
        }

        this._log("=== API Query ( normal mode )");
        this._log("api_url: " + api_url);
        this._log("args:");
        this._log(args);

        let async = true;

        let user = this.getUser();
        let xToken = urlParams['xToken'] != undefined ? urlParams['xToken'] : user.xToken;

        args['xToken'] = xToken;

        if (args['async'] == 1) {
            async = false;
        }
        args['rp_data_type'] = 'json';
        let ret = await axios.post(this.getConfig().api_url, qs.stringify(args));

        cb_func(ret['data']);
    }

    ui() {
        return ui;
    }

    async query_app(opts) {
        let path = "";
        if (!/^\//.test(opts.path)) {
            path = "/" + opts.path;
        } else {
            path = opts.path;
        }
        let url = this.getConfig().app_url + path;

        let user = this.getUser();
        let data = opts.data

        let ajaxOpts = {
            url: url,
            method: opts.method ? opts.method : "post",
            data: opts.data,
            headers: {
                "Authorization": "Bearer " + user.xToken
            }
        }
        let ret = await axios(url, ajaxOpts)
        return ret;
    }


    async queryV1(m, args) {
        var api_url = this.getConfig().api_url;
        if (typeof args == 'object') {
            args['method'] = m;
        } else {
            args = { 'method': m };
        }

        this._log("=== API Query ( normal mode )");
        this._log("api_url: " + api_url);
        this._log("args:");
        this._log(args);

        let async = true;


        let user = this.getUser();
        let xToken = urlParams['xToken'] != undefined ? urlParams['xToken'] : user.xToken;
        args['xToken'] = xToken;

        if (args['async'] == 1) {
            async = false;
        }
        args['rp_data_type'] = 'json';
        let ret = await axios.post(api_url, new URLSearchParams(args), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        return ret;
    }

    async queryV2(opts) {
        return await this.query_new(opts);
    }

    async query_new(opts) {
        let path = "";
        if (!/^\//.test(opts.path)) {
            path = "/v2/" + opts.path;
        } else {
            path = opts.path;
        }
        let url = this.getConfig().wapi_url + path;

        let user = this.getUser();
        let xToken = urlParams['xToken'] != undefined ? urlParams['xToken'] : user.xToken;

        let ajaxOpts = {
            url: url,
            method: opts.method ? opts.method : "post",
            data: opts.data,
            headers: {
                "Authorization": "Bearer " + xToken
            }

        }
        let ret = await axios(url, ajaxOpts)
        return ret;
    }



    async query(opts, success, error) {
        let path = "";
        if (!/^\//.test(opts.path)) {
            path = "/v2/" + opts.path;
        } else {
            path = opts.path;
        }
        let url = this.getConfig().wapi_url + path;

        let user = this.getUser();
        let xToken = urlParams['xToken'] != undefined ? urlParams['xToken'] : user.xToken;

        let ajaxOpts = {
            url: url,
            type: opts.method ? opts.method : "GET",
            dataType: 'jsonp',
            data: opts.data,
            success: success,
            error: error,
            beforeSend: function (xhr) {
                xhr.setRequestHeader('Authorization', 'Bearer ' + xToken);
            }
        }

        if (ajaxOpts['type'].toLowerCase() == 'post') {
            ajaxOpts['dataType'] = "json";
        }

        if (opts['contentType'] != undefined && opts['contentType'] != '') {
            ajaxOpts['contentType'] = opts['contentType'];
        } else {
            ajaxOpts['contentType'] = "application/json"
        }
        jquery.ajax(ajaxOpts);

    }



    login(url) {
        if (typeof url == 'undefined') {
            url = window.location.href;
        }
        location.href = this.getConfig().pages.login + "?game=99&redirect=" + url;
        return false;
    }

    logout(url) {

        if (typeof url == 'undefined') {
            url = window.location.href;
        }
        location.href = this.getConfig().pages.login + "?action=logout&game=99&redirect=" + url;
        return false;
    }

    register(url) {
        if (typeof url == 'undefined') {
            url = window.location.href;
        }
        location.href = this.getConfig().pages.register + "?game=99&redirect=" + url;
        return false;

    }

    requirejs(jss) {
        for (let i = 0; i < jss.length; i++) {
            this.load(jss[i]);
        }
    }

    logoutProcess() {
        this.cookie(tokenKey, "", {
            domain: domain,
            path: '/'
        });
        this.cookie("xlUserId", "", {
            domain: domain,
            path: '/'
        });
        this.cookie("accountId", "", {
            domain: domain,
            path: '/'
        });
        this.cookie("xUsername", "", {
            domain: domain,
            path: '/'
        });
        this.cookie(expireKey, Date.now(), {
            domain: domain,
            path: '/'
        });

    }

    getWDeviceId() {
        if (this.cookie("wDeviceId") == null || this.cookie("wDeviceId") == "") {
            let id = this.generateRandomString(16);
            this.cookie("wDeviceId", id, {
                domain: domain,
                path: '/',
                expires: 365
            });
            return id;
        } else {
            return this.cookie("wDeviceId");
        }
    }

    loginProcess(p) {

        this.cookie(tokenKey, p['xToken'], {
            domain: domain,
            path: '/'
        });
        this.cookie("xlUserId", p['id'], {
            domain: domain,
            path: '/'
        });
        this.cookie("accountId", p['id'], {
            domain: domain,
            path: '/'
        });
        this.cookie("xUsername", p['account_name'], {
            domain: domain,
            path: '/'
        });
        this.cookie(expireKey, Date.now() + 1800000, {
            domain: domain,
            path: '/'
        });

    }

    async loginByToken() {
        let ret = await this.queryV1("account.get_memberid");
        try {
            this.loginProcess({
                xToken: urlParams['xToken'],
                id: ret['data']['data']['memberid']
            });
        } catch (e) {
            console.log(e);
        }
    }

    setTokenOnce(token) {
        this.xToken = token;
    }

    getUser() {
        let xlUserId = this.cookie("xlUserId");
        let xUserName = this.cookie("xUsername");
        let xToken = "";
        if (this.xToken == "") {
            xToken = this.cookie(tokenKey);
        } else {
            xToken = this.xToken;
        }
        return { xlUserId: xlUserId, xUserName: xUserName, xToken: xToken }
    }

    urlParam(p) {
        var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    async getUserGameList() {
        if (this.myGameList == null) {
            let ret = await this.queryV2({
                path: "game/list",
                data: {
                    "type": gameType,
                    "all": false
                }
            })
            this.myGameList = ret.data.games;
        }
        return this.myGameList;

    }

    async getGameList(opts) {
        if (this.gameList == null) {
            let ret = await this.queryV2({
                path: "game/list",
                data: {
                    "type": gameType,
                    "all": true
                }
            })
            this.gameList = ret.data.games;
        }
        return this.gameList;
    }

    async getServerList(appId) {
        try {
            let u = this.getUser();
            let ret = await mapi.queryV2({
                path: "game/" + appId + "/xluserid/" + u.xlUserId + "/servers"
            });

            return { "data": ret['data']['servers'] };
        } catch (e) {

        }

    }

    async getCharList(appId, sid) {
        try {
            let u = this.getUser();

            let ret = await mapi.queryV2({
                path: "game/" + appId + "/xluserid/" + u.xlUserId + "/server/" + sid + "/characters"
            });

            return { "data": ret['data']['characters'], "canStore": ret['data']['canStore'] };
        } catch (e) {

        }
    }

    islogin() {
        return this.isLogin();
    }

    isLogin() {
        if (this.cookie(tokenKey) == "" || this.cookie(tokenKey) == null) {
            return false;
        } else {
            if (this.cookie(expireKey) <= (new Date().getTime())) {
                console.log("expire");
                return false;
            }
            return true;
        }
    }

    cookie(key, value, options) {
        // key and at least value given, set cookie...
        if (arguments.length > 1 && String(value) !== "[object Object]") {
            options = jquery.extend({}, options);

            if (value === null || value === undefined) {
                options.expires = -1;
            }

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setDate(t.getDate() + days);
            }

            value = String(value);

            return (document.cookie = [
                encodeURIComponent(key), '=',
                options.raw ? value : cookie_encode(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path ? '; path=' + options.path : '',
                options.domain ? '; domain=' + options.domain : '',
                options.secure ? '; secure' : ''
            ].join(''));
        }

        // key and possibly options given, get cookie...
        options = value || {};
        var result, decode = options.raw ? function (s) { return s; } : decodeURIComponent;
        return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? decode(result[1]) : null;
    }

    _log(t) {
        if (mapi.debug) {
            console.log(t);
        }
    }


    async alert(opts) {
        let msg = "";
        if (typeof opts == 'object') {
            msg = opts['msg'];
        } else {
            msg = opts;
        }
        await Swal.fire({
            text: msg,
            allowOutsideClick: false
        });
        return;
    }

    async confirm(msg) {
        let r = await Swal.fire({
            text: msg,
            icon: "question",
            showCancelButton: true,
            allowOutsideClick: false
        });

        if (r.isConfirmed) {
            return true;
        } else {
            return false;
        }
    }

    async prompt(msg, defaultVal, type) {

        const ret = await Swal.fire({
            title: msg,
            input: type ? type : 'text',
            inputValue: defaultVal,
            showCancelButton: true,
        });
        if (ret.value == undefined) {
            return "";
        }
        return ret.value;
    }

    toast(type, msg) {
        const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
        Toast.fire({
            icon: type,
            title: msg
        });
    }

    async cmp() {
        if (this.cookie("cmp_1") == null) {
            // 取得預設值
            return JSON.parse(this.cookie("cmp_default"));
            /*
            return {
                'ad_storage': 'denied',
                'ad_user_data': 'denied',
                'ad_personalization': 'denied',
                'analytics_storage': 'denied',
                'functionality_storage': 'denied',
                'personalization_storage': 'denied',
                'security_storage': 'denied',
            }
            */
        } else {
            let c1 = this.cookie("cmp_1") == "1" ? true : false;
            let c2 = this.cookie("cmp_2") == "1" ? true : false;;
            let c3 = this.cookie("cmp_3") == "1" ? true : false;;

            return {
                'ad_storage': c1 || c3 ? 'granted' : 'denied',
                'ad_user_data': c1 || c3 ? 'granted' : 'denied',
                'ad_personalization': c3 ? 'granted' : 'denied',
                'analytics_storage': c3 || c1 ? 'granted' : 'denied',
                'functionality_storage': c2 ? 'granted' : 'denied',
                'personalization_storage': c3 || c2 ? 'granted' : 'denied',
                'security_storage': 'denied',
            }
        }

    }

    generateRandomString(length) {
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789_";
        let result = "";
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * charset.length);
            result += charset.charAt(randomIndex);
        }
        return result;
    }

    getRecaptchaToken() {

    }
}

export default new mapi1();